import { IEventsDashboardData, EventType } from 'src/apis/dashboard/dashboard.interfaces';
import { getDashboardNavigationPaths } from 'src/apis/dashboard/dashboard.helpers';
import dayjs from 'dayjs';

const navigationPaths = getDashboardNavigationPaths();

export const eventsDashboardNewMock: IEventsDashboardData = {
  actionItems: {
    todayEvents: {
      count: 3,
      ongoing: 1,
      upcoming: 2,
      items: [
        {
          id: 'today-1',
          type: 'event_today',
          title: 'Ongoing: Annual Science Exhibition',
          description: 'Science exhibition currently in progress',
          eventId: 'event-001',
          eventName: 'Annual Science Exhibition',
          priority: 'high',
          navigationPath: navigationPaths.events.list,
        },
        {
          id: 'today-2',
          type: 'event_today',
          title: 'Upcoming: Mathematics Olympiad',
          description: 'Scheduled for 2:00 PM today',
          eventId: 'event-002',
          eventName: 'Mathematics Olympiad',
          priority: 'high',
          dueTime: '14:00',
          navigationPath: navigationPaths.events.list,
        },
        {
          id: 'today-3',
          type: 'event_today',
          title: 'Upcoming: Parent-Teacher Meeting',
          description: 'Scheduled for 4:00 PM today',
          eventId: 'event-003',
          eventName: 'Parent-Teacher Meeting',
          priority: 'medium',
          dueTime: '16:00',
          navigationPath: navigationPaths.events.meetings,
        },
      ],
    },
    todos: {
      pending: 8,
      inProgress: 3,
      items: [
        {
          id: 'todo-1',
          type: 'setup_pending',
          title: 'Setup Pending - Republic Day Celebration',
          description: 'Venue decoration and sound system setup',
          eventId: 'event-004',
          eventName: 'Republic Day Celebration',
          priority: 'high',
          checklistItems: ['Venue decoration', 'Sound system', 'Stage setup'],
          navigationPath: navigationPaths.events.list,
        },
        {
          id: 'todo-2',
          type: 'setup_pending',
          title: 'Setup Pending - Annual Sports Day',
          description: 'Equipment and track preparation',
          eventId: 'event-005',
          eventName: 'Annual Sports Day',
          priority: 'medium',
          checklistItems: ['Track preparation', 'Equipment check'],
          navigationPath: navigationPaths.events.list,
        },
        {
          id: 'todo-3',
          type: 'approval_request',
          title: 'Approval Request - Cultural Fest',
          description: 'Budget approval pending',
          eventId: 'event-006',
          eventName: 'Cultural Fest',
          priority: 'medium',
          navigationPath: navigationPaths.events.list,
        },
      ],
    },
  },
  upcomingItems: {
    events: [
      {
        id: 'event-007',
        type: EventType.HOLIDAY,
        title: 'Republic Day',
        description: 'National holiday',
        startDate: dayjs().add(5, 'days').toISOString(),
        endDate: dayjs().add(5, 'days').toISOString(),
        navigationPath: navigationPaths.events.list,
      },
      {
        id: 'event-008',
        type: EventType.EXAM,
        title: 'Term 1 Examinations',
        description: 'Annual term examinations',
        startDate: dayjs().add(12, 'days').toISOString(),
        endDate: dayjs().add(20, 'days').toISOString(),
        navigationPath: navigationPaths.events.list,
      },
      {
        id: 'event-009',
        type: EventType.SPORT,
        title: 'Inter-School Cricket Tournament',
        description: 'Cricket tournament with neighboring schools',
        startDate: dayjs().add(18, 'days').toISOString(),
        endDate: dayjs().add(20, 'days').toISOString(),
        location: 'School Ground',
        navigationPath: navigationPaths.events.list,
      },
      {
        id: 'event-010',
        type: EventType.CULTURAL,
        title: 'Annual Day Celebration',
        description: 'School annual day with cultural programs',
        startDate: dayjs().add(25, 'days').toISOString(),
        endDate: dayjs().add(25, 'days').toISOString(),
        location: 'School Auditorium',
        navigationPath: navigationPaths.events.list,
      },
      {
        id: 'event-011',
        type: EventType.MEETING,
        title: 'PTA Meeting',
        description: 'Parent-Teacher Association meeting',
        startDate: dayjs().add(8, 'days').toISOString(),
        startTime: '10:00',
        endTime: '12:00',
        location: 'Conference Hall',
        navigationPath: navigationPaths.events.meetings,
      },
    ],
    deadlines: [
      {
        id: 'deadline-1',
        type: EventType.EXAM,
        title: 'Exam Registration Deadline',
        description: 'Last date for exam registration',
        startDate: dayjs().add(10, 'days').toISOString(),
        registrationDeadline: dayjs().add(10, 'days').toISOString(),
        navigationPath: navigationPaths.events.list,
      },
      {
        id: 'deadline-2',
        type: EventType.SPORT,
        title: 'Sports Day Participation Deadline',
        description: 'Last date to register for sports events',
        startDate: dayjs().add(15, 'days').toISOString(),
        registrationDeadline: dayjs().add(15, 'days').toISOString(),
        navigationPath: navigationPaths.events.list,
      },
    ],
  },
  calendarEvents: [
    {
      id: 'cal-1',
      type: EventType.HOLIDAY,
      title: 'Republic Day',
      date: dayjs().add(5, 'days').format('YYYY-MM-DD'),
      color: '#f44336',
      navigationPath: navigationPaths.events.list,
    },
    {
      id: 'cal-2',
      type: EventType.MEETING,
      title: 'PTA Meeting',
      date: dayjs().add(8, 'days').format('YYYY-MM-DD'),
      startTime: '10:00',
      color: '#2196f3',
      navigationPath: navigationPaths.events.meetings,
    },
    {
      id: 'cal-3',
      type: EventType.EXAM,
      title: 'Term 1 Exams Start',
      date: dayjs().add(12, 'days').format('YYYY-MM-DD'),
      color: '#ff9800',
      navigationPath: navigationPaths.events.list,
    },
    {
      id: 'cal-4',
      type: EventType.SPORT,
      title: 'Cricket Tournament',
      date: dayjs().add(18, 'days').format('YYYY-MM-DD'),
      color: '#4caf50',
      navigationPath: navigationPaths.events.list,
    },
    {
      id: 'cal-5',
      type: EventType.CULTURAL,
      title: 'Annual Day',
      date: dayjs().add(25, 'days').format('YYYY-MM-DD'),
      color: '#9c27b0',
      navigationPath: navigationPaths.events.list,
    },
  ],
  summary: {
    totalEvents: 45,
    completed: 32,
    cancelled: 2,
    completionRate: 94.1,
    averageAttendance: 280,
    byType: {
      [EventType.EXAM]: 12,
      [EventType.SPORT]: 8,
      [EventType.CULTURAL]: 6,
      [EventType.MEETING]: 10,
      [EventType.HOLIDAY]: 5,
      [EventType.WORKSHOP]: 3,
      [EventType.SEMINAR]: 1,
    },
  },
  recentActivity: [
    {
      id: 'activity-1',
      type: 'event_completed',
      description: 'Science Exhibition completed successfully',
      eventName: 'Annual Science Exhibition',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      navigationPath: navigationPaths.events.list,
    },
    {
      id: 'activity-2',
      type: 'event_created',
      description: 'New event created - Mathematics Olympiad',
      eventName: 'Mathematics Olympiad',
      timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
      navigationPath: navigationPaths.events.list,
    },
    {
      id: 'activity-3',
      type: 'event_cancelled',
      description: 'Event cancelled - Guest Lecture',
      eventName: 'Guest Lecture on Career Guidance',
      timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
      navigationPath: navigationPaths.events.list,
    },
  ],
  timeRange: {
    startDate: '2024-01-01',
    endDate: '2024-01-31',
  },
};
